module.exports = "/static/media/lineto-circular-mediumitalic.f920fb1f.woff2";